(function () {
  'use strict';

  var overlay = document.getElementById('NewsletterPopupOverlay');
  if (!overlay) return;

  var STORAGE_KEY = 'pfNewsletterPopupDismissed';
  var closeBtn = document.getElementById('NewsletterPopupClose');

  function open() {
    overlay.classList.add('is-open');
    document.body.classList.add('pf-modal-open');
  }

  function close() {
    overlay.classList.remove('is-open');
    document.body.classList.remove('pf-modal-open');
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  var alreadyDismissed = false;
  try { alreadyDismissed = localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}

  if (!alreadyDismissed) {
    setTimeout(open, 4000);
  }

  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });

  var form = overlay.querySelector('form');
  if (form) {
    form.addEventListener('submit', function () {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    });
  }
})();
